import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import { ToastContainer } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';

function App() {  

  return (
    <BrowserRouter basename="/">
      <Routes />
      <ToastContainer/>
    </BrowserRouter>
  );
}

export default App;
